import { SEO } from '../components/SEO';
import { PortalLayout } from '../components/PortalLayout';
import { PortalSidebar } from '../components/PortalSidebar';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { ScrollReveal } from '../components/ScrollReveal';
import { complianceGuides } from '../data/complianceGuides';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const guidesSidebarGroups = [
  { id: 'guides', label: 'All Guides', items: complianceGuides.map((g) => ({ id: g.id, label: `${g.number} ${g.title}`, href: `/compliance-guides/${g.id}` })) },
];

const ComplianceGuides = () => (
  <>
    <SEO
      title="DPDPA Compliance Guides — Gap Assessment, DPIA, Breach Response"
      description="Step-by-step DPDPA compliance playbooks: gap assessments, DPIAs, consent notice drafting, 72-hour breach response, RoPA building and cross-border transfer compliance."
      path="/compliance-guides"
    />
    <PortalLayout
      breadcrumb={<Breadcrumbs trail={[{ label: 'Compliance Guides' }]} />}
      sidebar={<PortalSidebar heading="Compliance Guides" headingHref="/compliance-guides" groups={guidesSidebarGroups} defaultOpenGroupId="guides" />}
    >
      <div data-testid="compliance-guides-page" className="max-w-3xl">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-saffron-600 mb-3">Practitioner Playbooks</p>
        <h1 className="font-serif text-3xl sm:text-4xl text-navy leading-tight mb-4">Compliance Guides</h1>
        <p className="text-gray-600 leading-relaxed mb-10">
          Step-by-step playbooks that turn the Act's language into an operational programme — gap assessment, DPIAs, consent design, breach response, RoPA and cross-border transfers.
        </p>

        <div className="space-y-8" data-testid="guides-list-section">
          {complianceGuides.map((g) => (
            <ScrollReveal key={g.id}>
              <Link
                to={`/compliance-guides/${g.id}`}
                data-testid={`guide-card-${g.id}`}
                className="group grid grid-cols-1 sm:grid-cols-12 gap-4 sm:gap-8 border-b border-gray-200 pb-8 block"
              >
                <div className="sm:col-span-2">
                  <span className="font-serif text-4xl text-gray-200 group-hover:text-saffron/40 transition-colors">{g.number}</span>
                </div>
                <div className="sm:col-span-10">
                  <h2 className="font-serif text-xl sm:text-2xl text-navy mb-2 group-hover:text-saffron-600 transition-colors">{g.title}</h2>
                  <p className="text-gray-500 mb-3 leading-relaxed text-sm">{g.summary}</p>
                  <span className="text-sm text-navy font-medium flex items-center gap-1">Read full guide <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" /></span>
                </div>
              </Link>
            </ScrollReveal>
          ))}
        </div>

        <div className="bg-navy rounded-sm mt-14 p-8 text-center" data-testid="guides-cta-section">
          <h2 className="font-serif text-2xl text-white mb-5">Need ready-made templates for these workflows?</h2>
          <Link to="/templates" data-testid="guides-cta-templates-link" className="inline-flex items-center gap-2 bg-saffron text-white px-6 py-3 rounded-sm font-medium hover:bg-white hover:text-navy transition-colors">
            Browse Templates <ArrowRight size={16} />
          </Link>
        </div>
      </div>
    </PortalLayout>
  </>
);

export default ComplianceGuides;
